import React from 'react';
import '../../css/shared/Footer.css';
function Footer() {
  return (
    <footer class="page-footer font-small  bottom-fixed" id="footerbackground">
      <div class="footer-copyright text-center bg-white" >
        <hr id="footerhr" />
        <div className="footerTextDiv">
        <p 
        id="footercontain">© Copyright Transnet 2021. All right reserved.</p>
        </div>
      </div>
    </footer>
  );
}
export default Footer;